export function addCopiedDiscountIdToConditionFilter<T extends { promo_code_discount_ids?: Array<string> }>(
  condition: T,
  sourceDiscountId: string,
  copiedDiscountId: string,
): T {
  const discountIds = condition.promo_code_discount_ids ?? [];

  if (!discountIds.includes(sourceDiscountId) || discountIds.includes(copiedDiscountId)) {
    return condition;
  }

  return {
    ...condition,
    promo_code_discount_ids: [...discountIds, copiedDiscountId],
  };
}
